var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags has-addons generation-tag"},[_c('span',{staticClass:"tag is-dark"},[_vm._v(_vm._s(_vm.generationNumber(_vm.generationId)))]),_c('span',{staticClass:"tag has-text-white",style:({ backgroundColor: _vm.generationColor(_vm.generationId) })},[_vm._v(_vm._s(_vm.generationName(_vm.generationId)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }